export default function TypicalMistakes() {
  const mistakes = [
    { icon: 'ri-speed-up-line', text: 'Начинают продавать слишком рано — презентация до того, как клиент рассказал о ситуации' },
    { icon: 'ri-file-list-2-line', text: 'Задают вопросы ради вопросов — набор стандартных фраз без цели понять клиента' },
    { icon: 'ri-stop-circle-line', text: 'Перебивают клиента — не дают договорить, вставляют свои комментарии' },
    { icon: 'ri-chat-settings-line', text: 'Спорят с клиентом — пытаются доказать, что клиент неправ' },
    { icon: 'ri-headphone-line', text: 'Не слушают ответы — думают о следующем вопросе, пока клиент говорит' },
    { icon: 'ri-timer-line', text: 'Переходят к презентации через две минуты разговора — не накопили достаточно информации' },
    { icon: 'ri-emotion-unhappy-line', text: 'Боятся задавать неудобные вопросы — про деньги, конкурентов, причины прошлых неудач' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-error-warning-line"></i>
            Работа над ошибками
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Типичные ошибки менеджеров при диагностике
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Даже опытные менеджеры совершают эти ошибки. На тренинге мы разбираем каждую и отрабатываем правильные техники на реальных переговорах.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-5xl mx-auto">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-white border border-red-100 rounded-xl p-5 hover:border-red-200 transition-colors group">
              <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-red-100 transition-colors">
                <i className={`${item.icon} text-red-500 text-lg`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}